import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "value"]

import AppFormGroup from '@/core/components/form/AppFormGroup.vue';

interface AppColorInputProps {
	id: string;
	label: string;
	errors?: string[];
	modelValue?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppColorInput',
  props: {
    id: {},
    label: {},
    errors: {},
    modelValue: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const inputUpdated = (e) => {
	emit('update:modelValue', e.target.value.substring(1));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppFormGroup, {
    id: _ctx.id,
    label: _ctx.label,
    errors: _ctx.errors,
    class: "color-input-group"
  }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        type: "color",
        id: _ctx.id,
        value: `#${_ctx.modelValue}`,
        onInput: inputUpdated
      }, null, 40, _hoisted_1),
      _createElementVNode("span", {
        style: _normalizeStyle({
			color: _ctx.modelValue,
		})
      }, " #" + _toDisplayString(_ctx.modelValue), 5)
    ]),
    _: 1
  }, 8, ["id", "label", "errors"]))
}
}

})